import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';

export const InProgress = ({ customText }) => {
    return (
        <>
            <LoadingOutlined /> In Progress - {customText}
        </>
    );
};
